
import { defineComponent } from 'vue'
import ButtonDefault from '@/components/ui/ButtonDefault.vue'
import { TitleBanner, TextBanner } from '@/config/variables'
import { goToElement } from '@/use/navigation'
import { theme } from '@/config/styles'

const __default__ = defineComponent({
    components: {
        ButtonDefault
    },
    setup() {
        return {
            titleBanner: TitleBanner,
            textBanner: TextBanner,
            goToElement,
            theme
        }
    }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "b52ec7cc": (_ctx.theme.colors.primary.darker),
  "132ee084": (_ctx.theme.colors.white)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__